// Round 24 Item 3: synthetic End node — always rendered at the bottom of
// every CanvasWorkflowPanel. When `data.satisfied` is true the
// InteractivePlugin has an explicit EndScreen sub-item, so End reads as a
// courtesy marker (green check). Otherwise End is a warning chip so authors
// notice the implicit fallback exit. Read-only.
import React from "react";
import { Handle, Position } from "@xyflow/react";

export default function EndNode({ data }) {
  const label = (data && data.label) || "End";
  const satisfied = !!(data && data.satisfied);
  return (
    <div
      className={
        "canvas-wf-node canvas-wf-node--end" +
        (satisfied ? " canvas-wf-node--end-satisfied" : " canvas-wf-node--end-warning")
      }
    >
      <Handle type="target" id="in" position={Position.Left} />
      <div className="canvas-wf-node__head">
        <i className="material-icons">{satisfied ? "check_circle" : "flag"}</i>
        <span className="canvas-wf-node__kind">{label}</span>
      </div>
    </div>
  );
}
